import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Menu } from 'lucide-react';
import { navLinks } from '../../data/mock';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => location.pathname === href;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center group-hover:bg-[#2a4a73] transition-colors duration-300">
              <span className="text-white font-bold text-lg">IP</span>
            </div>
            <span className="text-xl font-semibold text-[#1e3a5f] tracking-tight">IpFunders</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                  isActive(link.href)
                    ? 'text-[#1e3a5f] bg-slate-100'
                    : 'text-slate-600 hover:text-[#1e3a5f] hover:bg-slate-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <Link to="/request-access">
              <Button className="bg-[#1e3a5f] hover:bg-[#2a4a73] text-white px-6 shadow-lg shadow-[#1e3a5f]/20 transition-all duration-300 hover:shadow-xl hover:shadow-[#1e3a5f]/30">
                Request Evaluation
              </Button>
            </Link>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" className="text-slate-600">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80 bg-white">
              <div className="flex flex-col h-full pt-8">
                <nav className="flex flex-col space-y-1">
                  {navLinks.map((link) => (
                    <Link
                      key={link.href}
                      to={link.href}
                      onClick={() => setIsOpen(false)}
                      className={`px-4 py-3 text-base font-medium rounded-lg transition-all duration-200 ${
                        isActive(link.href)
                          ? 'text-[#1e3a5f] bg-slate-100'
                          : 'text-slate-600 hover:text-[#1e3a5f] hover:bg-slate-50'
                      }`}
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
                <div className="mt-auto pb-8 space-y-3">
                  <Link to="/request-access" onClick={() => setIsOpen(false)}>
                    <Button className="w-full bg-[#1e3a5f] hover:bg-[#2a4a73] text-white">
                      Request Evaluation
                    </Button>
                  </Link>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export { Header };
